import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

// Small "?" help icon with a hover/tap tooltip. UI copy stays in English.
export function HelpHint({ children, side = "top", size = 14, className = "" }) {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="Help"
            data-testid="help-hint"
            onClick={(e) => e.preventDefault()}
            className={`inline-flex items-center justify-center text-slate-400 hover:text-[#2495D3] transition-colors ${className}`}
          >
            <HelpCircle size={size} />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          className="max-w-[280px] whitespace-normal bg-slate-900 p-3 text-[11px] leading-relaxed text-white shadow-xl"
        >
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
